<template>
  <div class="page-container" style="padding-top: 0">
    <a-tabs :default-active-key="tabKey" @change="handleTabChange">
      <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
        <component :is="item.key"></component>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import StudentTutor from './components/StudentTutor'
import LeagueAssistant from './components/LeagueAssistant'
import TutorTimeSetting from './components/TutorTimeSetting'
import { getAction, deleteAction } from '@api/manage'

export default {
  name: 'TutorStandBook',
  components: {
    StudentTutor,
    LeagueAssistant,
    TutorTimeSetting,
  },
  data() {
    return {
      tabKey: 'StudentTutor',
      tabPaneConfig: [
        {
          tab: '学生辅导',
          key: 'StudentTutor',
        },
        // {
        //   tab: '团辅方案',
        //   key: 'LeagueAssistant',
        // },
        {
          tab: '辅导时间设置',
          key: 'TutorTimeSetting',
        },
      ],
    }
  },
  created() {},
  computed: {
    importExcelUrl: function () {},
  },
  methods: {
    handleTabChange(key) {
      this.tabKey = key
    },
    getStudentTutor() {},
  },
}
</script>
<style scoped lang="less"></style>
